import styled from "styled-components";
import media from "constants/media";

export const Count = styled.span`
    position: absolute;
    bottom: 10px;
    left: 20px;

    color: var(--color-${({ error }) => (error ? "red" : "darkNight")});
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0;

    ${media.smUp`
        font-size: 15px;
        letter-spacing: 0;
        line-height: 25px;
    `}
`;

export const TextAreaContainer = styled.div`
    position: relative;
`;

export const TextArea = styled.textarea`
    position: relative;

    width: 100%;
    min-height: 175px;
    padding: 20px;

    font-family: var(--font-DINPro);

    border: 1px solid rgba(0, 23, 75, 0.1);

    resize: none;

    ::placeholder {
        color: var(--color-darkNight);

        opacity: 0.5;
    }

    :active,
    :focus {
        outline: none;
    }
`;

export const ErrorMessage = styled.div`
    position: absolute;
    bottom: 0;

    color: var(--color-red);
    font-size: 12px;
    line-height: 20px;
`;
